import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ValueProposition from "@/components/landing/ValueProposition";
import Expertises from "@/components/landing/Expertises";
import CaseStudies from "@/components/landing/CaseStudies";
import Methodology from "@/components/landing/Methodology";
import KeyFigures from "@/components/landing/KeyFigures";
import InsightsSection from "@/components/landing/InsightsSection";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        // Small delay so the section content is mounted before scrolling
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <Navbar />
      <Hero />
      <ValueProposition />
      <Expertises />
      <CaseStudies />
      <Methodology />
      <KeyFigures />
      <InsightsSection />
      <About />
      <Testimonials />
      <ContactSection />
      <Footer />
    </main>
  );
}
